import React,{useEffect} from 'react';
import Logo from '../../components/common/Logo';
import LoginForm from '../../components/Auth/LoginForm';
import {useNavigate} from 'react-router-dom';
import {loginAmbassador} from '../../actions/AmbassadorActions';
import swal from 'sweetalert'


function AmbassadorLogin(){
    const navigate = useNavigate();
    useEffect(() => {
        if(sessionStorage.getItem('ambDetail')){
            navigate('/ambassador/dashboard');
        }
    },[]);
    
    const onSubmit=(model)=>{
        loginAmbassador(model).then(res => {
            if (res.status) {
                navigate('/ambassador/dashboard');
            }
            else{
                swal(res.message,'','error')
            }
        })
        
    }
    return(
       <>
         {/* <div className='container-fluid'>
            <div className='row'>
                <div className='col-lg-12 mt-4 px-5 login_parentLogo'>
                    <Logo alt="Logo" className=""/>
                </div>
            </div>
        </div> */}
       <section className="py-5 login-page">
      
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6">
                    <div className="text-center">
                    <div className="login_logo_wrapper">
                        <Logo alt="Logo" className="mb-4"/>
                    </div>
                    </div>
                    <div className="login-box">
                        <div className="page-head">
                            <h2>Ambassador Login</h2>
                        </div>
                        <LoginForm onSubmit={onSubmit}/>
                    </div>
                </div>
            </div>
        </div>
    </section>
       </>
    );
}

export default AmbassadorLogin;



